import { MailPlus } from 'lucide-react'
import { useState } from 'react'

import { PageHeader } from '@/app/layouts/PageHeader'
import { EmptyState, ErrorState } from '@/components/ui/EmptyState'
import { PostListSkeleton } from '@/components/ui/Skeleton'
import { CenteredSpinner } from '@/components/ui/Spinner'
import { ConversationListItem, NewMessageDialog, useConversations } from '@/features/messages'
import { useInfiniteScroll } from '@/hooks/useInfiniteScroll'
import { useT } from '@/i18n'

/** 私信会话列表（D70–D72）。按最后一条消息倒序，停在这页时 30 秒刷新一次。 */
export function MessagesPage() {
  const t = useT()
  const [composing, setComposing] = useState(false)
  const query = useConversations()
  const sentinelRef = useInfiniteScroll({
    hasNextPage: Boolean(query.hasNextPage),
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
  })

  const conversations = query.data?.pages.flatMap((page) => page.items) ?? []

  return (
    <>
      <PageHeader title={t('messages.title')}>
        <div className="absolute right-3 top-2.5">
          <button
            type="button"
            onClick={() => setComposing(true)}
            aria-label={t('messages.new')}
            title={t('messages.new')}
            className="rounded-md p-2 hover:bg-surface-hover"
          >
            <MailPlus className="size-5" />
          </button>
        </div>
      </PageHeader>

      {query.isPending ? (
        <PostListSkeleton count={4} />
      ) : query.isError ? (
        <ErrorState message={query.error.message} onRetry={() => query.refetch()} />
      ) : conversations.length === 0 ? (
        <EmptyState title={t('messages.empty')} description={t('messages.emptyBody')} />
      ) : (
        <div>
          {conversations.map((conversation) => (
            <ConversationListItem key={conversation.id} conversation={conversation} />
          ))}
          <div ref={sentinelRef} aria-hidden className="h-px" />
          {query.isFetchingNextPage && <CenteredSpinner />}
        </div>
      )}

      {composing && <NewMessageDialog open onClose={() => setComposing(false)} />}
    </>
  )
}
